/** @jsx jsx */
import { Flex, FormGroup, FormLabel, Grid, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { FormikError, VALIDATION_TYPES } from "@/components/Formik";
import { FormikNumberInput } from "@/components/Formik/FormikNumberInput";
import { JobApplicationRate } from "@/data/job-applications/types/JobApplicationRate";

interface ApplyTotalPayoutProps {
  rate: JobApplicationRate;
  onChange: (value: number) => void;
}

export const ApplyTotalPayout: FC<ApplyTotalPayoutProps> = ({ rate, onChange }) => {
  const { t } = useTranslation("session");

  return (
    <Grid columns={["1fr", null, null, "1fr 1fr 1fr"]}>
      <Flex flexDirection="column">
        <FormGroup
          label={<FormLabel label={t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.PAYEXPRESS.TOTAL_PAYOUT")} required />}
          error={
            <FormikError
              name="payExpress.finalRatePerHour"
              overrideMessages={{
                [VALIDATION_TYPES.MORE_THAN]: t("common:VALIDATION_MESSAGES.MORE_THAN", {
                  value: 0,
                }),
                [VALIDATION_TYPES.TOO_BIG_NUMBER]: t(
                  "JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.APPLICATION_DETAILS.RATE_TOO_BIG",
                ),
                [VALIDATION_TYPES.MAX_LENGTH]: t(
                  "JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.APPLICATION_DETAILS.RATE_TOO_BIG",
                ),
              }}
            />
          }>
          <FormikNumberInput
            name="costs.finalRatePerHour"
            onChange={onChange}
            rightPlaceholder={
              <Paragraph size="p-md" color="n700">
                {rate.currency}/h
              </Paragraph>
            }
            precision={2}
            size="xl"
          />
        </FormGroup>
      </Flex>
    </Grid>
  );
};
